import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class GetAllUsersList extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Users/GetAll");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}
class GetASingleUser extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Users/GetByAdmin");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class UpdateUserAsAdmin extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Users/UpdateUserByAdmin");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class ChangeUserActivationBy extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Users/ChangeUserActivationBy");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class CreateASingleUser extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Users/Create");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class ChangeUserIsShow extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Users/ChangeUserIsShow");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetMasterStudentsList extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Users/GetMyStudentList");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class SetUserWallet extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Users/SetWallet");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetVipUsersList extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Users/GetVipUserList");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetUserByToken extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Users/GetByToken");
  }
}

class UpdateUserByToken extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Users/Update");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class ChangePasswordByUser extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Users/ChangePasswordForUser");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class DeleteASingleUserByAdmin extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Users/Delete");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetLiteUserById extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Users/GetByIdLight");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class BlockUserByMaster extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Users/BlockUser");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class UnblockUserByMaster extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Users/UnBlockUser");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetMasterBlockList extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Users/GetMasterBlockList");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetUserFamiliesForAdmin extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Users/GetUserFamiliesForAdmin");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetUserFamiliesForAdminByUserId extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Users/GetUserFamilyByUserId");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class ToggleVerifyUserFamily extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Users/UserFamilyVerifyToggle");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class UpdateUserLinks extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Users/UpdateUserLinks");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class UserActivitiesReportByDateTime extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Users/GetUsersActivitiesReportByDateTime");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetUsersReportByDateTime extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Users/GetUsersReportByDateTime");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class AssignLiteracyBadgeToMaster extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Users/AssignLiteracyBadgeToMaster");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetUsersByGoalAndBirthDate extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Users/GetAllUserByFilterOfGoalAndBirthdayAndHowToIntroduce");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetMasterPriceCategoriesDetails extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Users/GetMasterPriceCategoriesByUserId");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class UpdateMasterPriceCategoryCustomPercents extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Users/UpdateMasterPriceCategoriesUserMasterPrice");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class UpdateMasterPoints extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Users/UpdateUserPoint");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class UpdateMasterIntro extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Users/UpdateUserIntro");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

export {
  GetAllUsersList,
  GetASingleUser,
  UpdateUserAsAdmin,
  ChangeUserActivationBy,
  CreateASingleUser,
  ChangeUserIsShow,
  GetMasterStudentsList,
  SetUserWallet,
  GetVipUsersList,
  GetUserByToken,
  UpdateUserByToken,
  ChangePasswordByUser,
  DeleteASingleUserByAdmin,
  GetLiteUserById,
  BlockUserByMaster,
  UnblockUserByMaster,
  GetMasterBlockList,
  GetUserFamiliesForAdmin,
  GetUserFamiliesForAdminByUserId,
  ToggleVerifyUserFamily,
  UpdateUserLinks,
  UserActivitiesReportByDateTime,
  GetUsersReportByDateTime,
  AssignLiteracyBadgeToMaster,
  GetUsersByGoalAndBirthDate,
  GetMasterPriceCategoriesDetails,
  UpdateMasterPriceCategoryCustomPercents,
  UpdateMasterPoints,
  UpdateMasterIntro,
};
